import 'bootstrap';
import 'slick-carousel/slick/slick';
import styles from '/assets/scss/app.scss';
import scripts from '/assets/js/app.js';